<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-skeleton-loader v-if="$store.state.orders.retrieveLoader" transition="fade-transition" type="table"/>
      <template v-else>
        <v-col v-if="!ordersList.length" class="text-center py-5">
          <v-icon class="d-block" color="secondary" size="70">mdi-file</v-icon>
          <span class="d-block subtitle-1">No existen órdenes</span>
          <v-btn class="my-5" :to="{name: 'OrderCreate'}" v-if="showCreate" outlined>Crear una orden</v-btn>
        </v-col>
        <template v-else>
          <v-data-table :headers="headers" :items="ordersList" :items-per-page="pagination"  hide-default-header disable-sort mobile-breakpoint hide-default-footer  @click:row="(ordersList) => { $router.push({name: ordersList.status === 'draft' ? 'OrderUpdate' : 'OrderRetrieve', params: {id: ordersList.id}}) }" style="cursor: pointer">
            <!-- header -->
            <template v-slot:[`header`]="{ props: { headers } }">
              <VTableHeaders :headers="headers" @sort="setSort" />
            </template>
            <!-- end header -->
            <template v-slot:[`item.customer`]="{ item }">
              <span class="text--secondary font-weight-medium">{{item.customer.name}}</span>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <div class="text-right py-4" v-if="showStatus">
                <v-chip v-if="item.status === 'draft'" color="defaultGrey" text-color="secondary" small>Borrador</v-chip>
                <v-chip v-if="item.status === 'finalized'" color="defaultGrey" text-color="secondary" small>Finalizado<v-icon class="ml-1" x-small>mdi-check</v-icon></v-chip>
              </div>
            </template>
            <template v-slot:[`item.number`]="{ item }">
              <v-menu open-on-hover right offset-x transition="slide-x-transition" :nudge-width="140">
                <template v-slot:[`activator`]="{ on }">
                  <div v-on="on">
                    <span class="d-block">{{item.document.name}}</span>
                    <span class="d-block body-2 text--secondary font-weight-medium" v-if="item.status !== 'draft'">Nº {{item.number}}</span>
                  </div>
                </template>
                <v-card class="pa-0">
                  <v-subheader class="font-weight-medium background">{{item.document.name}}</v-subheader>
                  <v-card-text class="pa-0">
                    <template v-if="item.lines.length">
                      <v-row class="mx-0 px-2" v-for="p in item.lines.slice(0, 3)" :key="p.id">
                        <v-col cols="6">
                          <span class="text--secondary font-weight-medium">{{p.name}}</span>
                        </v-col>
                        <v-col cols="6" class="text-right">
                          <span class="d-block">$ {{p.amount | number}}</span>
                          <span class="d-block" v-if="item.lines.length > 3">y otros {{item.lines.length - 3}} productos</span>
                        </v-col>
                      </v-row>
                    </template>
                    <v-divider />
                  </v-card-text>
                  <v-card-actions class="text-center">
                    <v-spacer />
                    <v-btn :to="{name: item.status === 'draft' ? 'OrderUpdate' : 'OrderRetrieve', params: {id: item.id}}" text color="primary">Ver detalle <v-icon small>mdi-arrow-right</v-icon></v-btn>
                    <v-spacer />
                  </v-card-actions>
                </v-card>
              </v-menu>
            </template>
            <template v-slot:[`item.created`]="{ item }">
              <span>{{item.date | date}}</span>
            </template>
            <template v-slot:[`item.total`]="{ item }">
              <div class="text-right">
                <span class="body-2 text--secondary font-weight-medium">{{item.total | currency(item.currency)}}</span>
                <span class="ml-1">{{item.currency}}</span>
              </div>
            </template>
            <template v-slot:[`item.currency`]="{ item }">
              <span>{{item.currency}}</span>
            </template>
          </v-data-table>
          <template v-if="showPagination || showAll">
            <v-divider />
            <v-row class="mx-0" align="center">
              <v-col cols="12" class="text-center" v-if="showAll">
                <v-btn :to="{name: 'OrderList', query: showCriteria}" outlined color="secondary">Ver todas las órdenes</v-btn>
              </v-col>
              <template v-if="showPagination">
                <v-col cols="6">
                  <span class="body-2 text--secondary">{{count}} registros</span>
                </v-col>
                <v-col cols="6" class="text-right">
                  <v-pagination v-model="page" :length="totalPages" total-visible="6" />
                </v-col>
              </template>
            </v-row>
          </template>
        </template>
      </template>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import VTableHeaders from '@/components/VTable/VTableHeaders'
import ListViewMixin from '@/mixins/ListViewMixin'
export default {
  components: {
    VTableHeaders
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    headers: [
      { text: 'Cliente', value: 'customer', class: 'font-weight-bold', sortable: true },
      { text: '', value: 'status' },
      { text: 'Número', value: 'number', sortable: true },
      { text: 'Fecha', value: 'created', align: 'end', sortable: true },
      { text: 'Total', value: 'total', align: 'end', sortable: true }
    ]
  }),
  computed: mapState({
    count: state => state.orders.ordersCount,
    ordersList: state => state.orders.ordersList
  })
}
</script>